import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { ICashRegisterOperationWithParent } from '../interfaces';
import { CashRegisterOperationWithParentMapper } from '../mappers';

export type IGetCashRegisterOperationsRepoResponse = IRepoResponse<200, { data: ICashRegisterOperationWithParent[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetCashRegisterOperationsRepo = IRepo<[any], IGetCashRegisterOperationsRepoResponse>;

export const GetCashRegisterOperationsRepoType = Symbol.for('GetCashRegisterOperationsRepo');

@bind(GetCashRegisterOperationsRepoType)
export class GetCashRegisterOperationsRepo implements IGetCashRegisterOperationsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/cash_categories/all', query) });

      if (result.status === 200) {
        const data: ICashRegisterOperationWithParent[] = result.data.data.map((user) => CashRegisterOperationWithParentMapper.toDomain(user));
        const total: number = result.data.total;

        return { status: 200 as 200, response: { data, total } };
      } else {
        return { status: 400 as 400, response: 'Məlumatlar əldə edilə bilmədi' };
      }
    } catch (e) {
      return { status: 500 as 500, response: 'Şəbəkə ilə əlaqə qurula bilmədi' };
    }
  }
}
